"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = void 0;
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const _ui_1 = require("@ui");
const Cell = ({ cell, editRows, editValue, allEditedRows, isSticky, isExtraRow, idOfExtraRow, stickyOffset, isLast, isNextSticky, tableRowConfig, }) => {
    const { rowToHTML, extraRowToHTML, id: cellId, 
    // @ts-expect-error This seems to be undefined absolutely everywhere but I'll just keep it here in case in breaks somewhere
    onClick, editable, editComponent, groupBorder, width, minWidth, maxWidth, styles, } = cell.column;
    const handleStickyPosition = () => {
        if (isSticky) {
            return { left: stickyOffset || 0 };
        }
    };
    const cellProps = { ...cell.getCellProps() };
    const lastSticky = isLast && isSticky;
    const withShadow = !isLast && !isNextSticky && isSticky;
    const editableVal = typeof editable === 'function' ? editable(cell.row.original) : editable;
    const isValueEdited = (editValue, cellId) => {
        // value is not present at all - no need to update anything
        if (!(0, util_1.isValue)(editValue)) {
            return false;
        }
        // This sounds smart but would need more tweaking to get working correctly, eg: tracking previous value
        // if (typeof editValue[cellId] === "number") {
        //   return !Number.isNaN(editValue[cellId])
        // }
        // if (typeof editValue[cellId] === "string") {
        //   return editValue[cellId].length > 0
        // }
        return (0, util_1.isValue)(editValue[cellId]);
    };
    return (react_1.default.createElement("div", { onClick: onClick, className: (0, classnames_1.default)('cell', 'cell_' + cellId, {
            sticky: isSticky,
            'last-sticky-detection': lastSticky,
            'with-shadow-detection': withShadow,
            'is-extra-row': isExtraRow,
            'last-sticky': lastSticky,
            'with-border': !!groupBorder,
            'is-edited': isValueEdited(editValue, cellId),
            'is-selection': cellId === 'selection',
        }), ...cellProps, style: {
            flex: cellId === 'selection' || lastSticky ? 'initial' : '1 0 auto',
            width,
            minWidth,
            maxWidth,
            ...handleStickyPosition(),
            ...styles?.(cell.row.original),
            backgroundColor: tableRowConfig?.backgroundColor?.(cell.row.original),
            minHeight: (0, maybe_unwrap_1.unwrapMaybe)(tableRowConfig?.minHeight),
        } },
        react_1.default.createElement("div", { className: 'cell-content' },
            editableVal && !isExtraRow ? (editComponent ? (editComponent({
                onChange: (val) => editRows(val),
                value: editValue && typeof editValue[cellId] !== typeof undefined
                    ? editValue[cellId]
                    : // @ts-expect-error this works but I couldn't be bothered trying to figure out why `keyof T` cannot index `T`
                        cell.row.original[cellId],
                allEditedRows: allEditedRows ?? [],
                cell,
            })) : (react_1.default.createElement(_ui_1.Input, { style: _ui_1.Input.STYLES.UNDERLINE, size: _ui_1.Input.SIZES.LEAN, onChange: (val) => editRows(val), value: editValue && typeof editValue[cellId] !== typeof undefined
                    ? editValue[cellId]
                    : // @ts-expect-error this works but I couldn't be bothered trying to figure out why `keyof T` cannot index `T`
                        cell.row.original[cellId] }))) : (isExtraRow && (react_1.default.createElement(react_1.default.Fragment, null, (0, util_1.isValue)(extraRowToHTML) &&
                Array.isArray(extraRowToHTML(cell.row.original)) ? (react_1.default.createElement(react_1.default.Fragment, null, (0, util_1.isValue)(idOfExtraRow)
                ? extraRowToHTML(cell.row.original)?.[idOfExtraRow]
                : null)) : (react_1.default.createElement(react_1.default.Fragment, null, extraRowToHTML ? extraRowToHTML(cell.row.original) : null))))),
            !isExtraRow &&
                !editableVal &&
                (rowToHTML ? rowToHTML(cell.row.original) : cell.render('Cell')))));
};
exports.Cell = Cell;
exports.Cell.propTypes = {
    cell: prop_types_1.default.object,
    originalRow: prop_types_1.default.object,
    editRows: prop_types_1.default.func,
    editValue: prop_types_1.default.object,
    isSticky: prop_types_1.default.bool,
    groupBorder: prop_types_1.default.bool,
    stickyProperties: prop_types_1.default.object,
    allEditedRows: prop_types_1.default.array,
    showStickyLeft: prop_types_1.default.bool,
    showStickyRight: prop_types_1.default.bool,
};
exports.Cell.defaultProps = {
    cell: {},
    originalRow: {},
    editValue: null,
    isSticky: false,
    groupBorder: false,
    stickyProperties: null,
    allEditedRows: [],
    showStickyLeft: false,
    showStickyRight: false,
};
